import { createContext } from 'react'
import { initialState } from '../reducer/positionReducer'
import { actionTypes, ReducerPosition } from '../types'

/*
 * Copyright 2022-08-24 por Miguel Balloqui Ecomsur Holding S.A ©
 * Detalle: se crea useCheck por cambio a useReducer + Context
 */

interface PositionContext {
  state: ReducerPosition
  dispatch: React.Dispatch<actionTypes>
}

// Se crea un Contexto el cual le asignamos el tipo de CountContext el cual tendra nuestro state del reducer y nuestro dispatch
const PositionContext = createContext<PositionContext>({
  state: initialState,
  dispatch: () => {}
})

export default PositionContext
